import Popover from 'bootstrap/js/dist/popover';

const showPopover = (event) => {
  const element = event.target.closest?.('[data-bs-toggle="popover"]');
  if (!element) return;
  if (Popover.getInstance(element)) return;

  Popover.getOrCreateInstance(element).show();
};

export const enableDynamicPopovers = () => {
  document.addEventListener('mouseover', showPopover);
  document.addEventListener('focusin', showPopover);
};
